// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JCn1","left":"styles_left__2rf8t"};